import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";

export default function IntervalSelector({
  startDate = moment().subtract(30, "days"),
  endDate = moment(),
  onChange = null,
}) {
  return (
    <div className="interval-selector">
      <i className="fa fa-calendar"></i>
      <DateRangePicker
        onCallback={async (start, end) => {
          if (onChange) {
            onChange(start, end);
          }
        }}
        initialSettings={{
          startDate,
          endDate,
          ranges: {
            Yesterday: [
              moment().subtract(1, "days"),
              moment().subtract(1, "days"),
            ],
            "Last 2 weeks": [
              moment().subtract(14, "days"),
              moment().subtract(1, "days"),
            ],
            "Last 30 Days": [
              moment().subtract(30, "days"),
              moment().subtract(1, "days"),
            ],
            "This Month": [
              moment().startOf("month"),
              moment().subtract(1, "days"),
            ],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "Last 90 Days": [
              moment().subtract(90, "days"),
              moment().subtract(1, "days"),
            ],
            "This year": [
              moment().startOf("year"),
              moment().subtract(1, "days"),
            ],
            "Last year": [
              moment().subtract(1, "year").startOf("year"),
              moment().subtract(1, "year").endOf("year"),
            ],
          },
        }}
      >
        <input type="text" />
      </DateRangePicker>
    </div>
  );
}
